import React, { useEffect, useMemo } from 'react';
import NewTaskButton from 'components/Tasks/NewTaskButton';
import TaskList from 'components/Tasks/TaskList';
import { UncontrolledCollapse } from 'components/Utils/Collapse';
import TaskUtils from 'services/TaskUtils';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';

const PatientTasks = ({ patient }) => {
  const patientId = patient.id;

  const dispatch = useAppDispatch();
  const allTasks = useAppSelector((state) => state.tasks.byId);

  const patientTasks = allTasks[patientId];

  const archivedTasks = useMemo(() => TaskUtils.filterTasks(patientTasks, true), [patientTasks]);
  const activeTasks = useMemo(() => TaskUtils.filterTasks(patientTasks, false), [patientTasks]);

  useEffect(() => {
    dispatch(api.Tasks.getPatientTasks({ patientId }));
  }, [dispatch, patientId]);

  return (
    <div className="scroll-list task-list">
      <div className="pl-4 pt-4">
        <NewTaskButton patient={patient} />
      </div>
      <TaskList tasks={activeTasks} title="Active Tasks" hideFilter={true} />
      <UncontrolledCollapse title={`Archived Tasks (${archivedTasks.length})`}>
        <TaskList tasks={archivedTasks} hideFilter={true} />
      </UncontrolledCollapse>
    </div>
  );
};

export default PatientTasks;
